/* eslint-disable */
import React, { useCallback, useEffect, useState, useRef } from "react";
import Loadable from "../../components/Loadable";
import {
  DocumentIcon,
  InvestigatorIcon,
  PersonSvg,
} from "../../assets/common-svg/CommonSvg";
// import { CustomChipCard } from "../../components/custom-product-cards/custom-chip-card/CustomChipCard";
import { CustomWrapperCard } from "../../components/custom-product-cards/custom-wrapper-card/CustomWrapperCard";
import CustomDetailComponent from "../../components/doctor-detail-component/DocotorDetail";
import TrialInfoComponent from "../../components/trial-info-component/TrialInfoComponent";
import CustomTable from "../../components/custom-table/CustomTable";
import { useLocation, useNavigate, useParams } from "react-router";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import { Typography, useTheme, Skeleton } from "@mui/material";
const TaskManagementHeader = Loadable(
  React.lazy(() =>
    import("../../components/task-management-header/TaskManagementHeader")
  )
);
import SkeletonLoader from "../../utilites/SkeltonLoader";
import DeleteConfirmContent from "../../components/modal-contents/DeleteConfirmModalContent";
import {
  AddPhase,
  EditSubjectPhase,
  ReAssignPiEditor,
  VisitFrequency,
} from "../../utils/formik/initialValues";
import {
  ReAssignValidationSchema,
  addFormExportSchema,
  addPhaseValidationSchema,
  editSubjectPhaseValidationSchema,
  validateEditSubjectId,
  visitFrequencyValidationSchema,
} from "../../utils/formik/validationSchema";
import CustomModel from "../../components/custom-model/CustomModel";
import { productDetailsData } from "../../utils/tableData";
import api from "../../services/request";
import SkeltonLoaderHeader from "../../utilites/SkeltonLoaderHeader";
import NoDataCard from "../../components/no-data-card.js";
import { useDispatch, useSelector } from "react-redux";
import {
  setFormTemplateDropList,
  setIAQA,
  setPICoordinator,
  setPhaseType,
  setTrialManager,
} from "../../store/reducers/sub-admin-dropdown.js";
import SubjectApi from "../../services/subjectService.js";
import { setPhaseDetail } from "../../store/reducers/phase-reducer.js";
import moment from "moment";
import PhaseApi from "../../services/phase.js";
import SubAdminApi from "../../services/subAdminService.js";
import {
  AddNewSubjectPhase,
  exportFormCsv,
  editSubjectId,
} from "../../utils/formik/initialValues";
import { addNewSubjectPhaseValidationSchema } from "../../utils/formik/validationSchema";
import DiseaseManagementApi from "../../services/diseaseService";
import { GenderList } from "../../utils/common";
import ProductApi from "../../services/productService.js";
import AddPiAndEditorForAllModalContent from "../../components/modal-contents/AddPiAndEditorForAllModalContent .js";
import { useSearchParams } from "react-router-dom";
import { downloadCsv, jsonToCsv, parseToDate } from "../../utils/utils.js";
import { extraFormOptions } from "../../bmr/utils/common/utils.js"
import { exportToExcelWithDropdowns, exportToExcel } from "../../utils/excelExportSubject.js";
import { isEmpty } from "lodash";
import ConfirmationModal from "../../components/modal-contents/ConfirmationModal.js";
import { formTemplateDropdownList } from "../../utils/common";
import * as Yup from "yup";
import CustomPhaseModel from "../../components/custom-modal/CustomPhaseModal.js";
import { getUserHasAccess } from "../../utils/authorities.js";
import { notify } from "../../bmr/utils/methods/notification.js";
import CustomTabs from "../../components/custom-tabs/CustomTabs.js";
import CustomAccordion from "../../components/custom-accordion/CustomAccordion.js";
// import CustomProgressTracker from "../../components/custom-progress-tracker/CustomProgressTracker.js";
import CustomDrawer from "../../components/custom-drawer/CustomDrawer.js";
import HeaderBackNav from "../../components/header-back-navigation/HeaderBackNav.js";
import CustomSearchbar from "../../components/custom-searchbar/CustomSearchbar.js";

const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);


  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};


const scrollToPatientListing = () => {
  const patientListingSection = document.querySelector('.min-h-\\[25rem\\]');
  if (patientListingSection) {
    patientListingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};

export const convertSubjectData = (data, curr_page, page_details, order) => {
  return data?.map((sub, index) => {
    let SerialNo =
      order == "asc"
        ? page_details?.no_of_records - (curr_page - 1) * 10 - index
        : index + 1 + (curr_page - 1) * 10;
    let transformedPatientId = sub?.patient_id || "--";
    let transformId = sub?.id;
    let transformedSubjectInitial =
      sub?.first_name + " " + sub?.last_name || "";
    let transformedPatientStatus =
      sub?.life_status == "lost" ? (
        <div className="h-3 w-3 rounded-full bg-yellow-500"></div>
      ) : sub?.life_status == "alive" ? (
        <div className="h-3 w-3 rounded-full bg-green-500"></div>
      ) : (
        <div className="h-3 w-3 rounded-full bg-red-500"></div>
      )
      let transformedLastVisitType = sub?.last_visit_type || "--";
    let transformeInvestigator =
      sub?.investigatorDetails?.name || "Not Assigned";
    let transformedCreatedBy = sub?.created_By?.name  || "--"
    let editorData = [];
  if (sub?.userPi?.length) {
  editorData = sub.userPi.map(pi => ({
    id: pi.id,
    name: pi.name,
    role: pi.role_title,
  }));
}
const transformedEditorCount = (editorData.length > 1) 
  ? editorData.length.toString() 
  : (editorData.length === 1) 
    ? editorData[0]?.name || "--" 
    : "--";   


    let cycleCount = sub?.cycle;
    let gender = sub?.gender;
    let lastAppointmentDate = sub?.last_visit_type && sub?.last_appointment_date
      ? moment(sub?.last_appointment_date).format("DD/MM/YYYY")
      : sub?.last_visit_type && !sub?.last_appointment_date
        ? moment(sub?.created_at).format("DD/MM/YYYY")
        : "--";
    let hospitalName = sub?.hospitalDetails?.name;
    let roleName = sub?.created_By?.role_details?.title ||  "N/A"

    return {
      displayData: [
        SerialNo,
        transformedPatientId,
        transformedSubjectInitial,
        transformedPatientStatus,
        transformedLastVisitType,
        transformeInvestigator,
        transformedCreatedBy,
        transformedEditorCount, 
        cycleCount,
        gender,
        hospitalName,
        roleName,
        lastAppointmentDate,
        transformId,
      ],
      internalData: {
        editorData, 
        rowId: transformId,
        originalData: sub
      }
    };
  });
};

export const ProductDetails = () => {
  const { role_id, auth } = useSelector((state) => state.loginData);
  const userAuthority = auth || [];
  const [activeTab, setActiveTab] = useState(null);
    const [isEditFormLoading, setIsEditFormLoading] = useState(false);

  const { pICoordinator, trialManager, iAQA, phaseType, formTemplateDropList } =
    useSelector((state) => state?.subAdminDropdown);
  const location = useLocation(); // For state
  const [loading, setLoading] = useState({
    page: true,
    phaseList: false,
    phaseDetail: false,
    subjectList: false,
    table: false
  });
  
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openAddTrailPhaseModal, setOpenAddTrailPhaseModal] = useState(false);
  const [phaseListData, setPhaseListData] = useState(null);
  const [phaseListDetails, setPhaseListDetails] = useState({});
  const [assigningPiLoader, setAssignPiLoader] = useState(false);
  const [openAssignForAllModal, setOpenAssignForAllModal] = useState(false);
  const [sumbitPiEditorValues, setSubmitPiEditorValues] = useState({});
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [isAddPrLoading, setIsAddPrLoading] = useState(false);
  const [isAddSubjectLoading, SetIsAddSubjectLoading] = useState(false);
  const [editorList, setEditorList] = useState([]);
  // const [subjectData, setSubjectData] = useState(productDetailsData);
  const [subjectData, setSubjectData] = useState(() => productDetailsData(null));
  const [tableFilters, setTablesFilters] = useState({ searchData: "" });
  const [totalPage, setTotalPage] = useState(1);
  const [subjectListData, setSubjectListData] = useState([]);
  const [initialValues, setInitialValues] = useState(ReAssignPiEditor);
  const [currentPage, setCurrentpage] = useState(1);
  const [pIList, setPIList] = useState([]);
  const [diseaseList, setDiseaseList] = useState([]);
  const navigate = useNavigate();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [piId, setPiID] = useState(null);
  const [productDetails, setProductDetails] = useState(null);
  const [editorId, setEditorId] = useState(null);
  const [openAddSubjectModal, setOpenAddSubjectModal] = useState(false);
  const [rowId, setRowId] = useState(null);
  const [openExportModal, setOpenExportModal] = useState(false);
  const [openEditSubjectIdModal, setOpenEditSubjectIdModal] = useState(false);
  const [disableButton, setDisableButton] = useState(true);
  const [exportType, setExportType] = useState("csv");
  const [searchParams] = useSearchParams();
  const [exportLoading, setExportLoading] = useState(false);
  const [editIdLoading, setEditIdLoading] = useState(false);
  const [patientCycleConfirm, setPatientCycleConfirm] = useState(false);
  const [patientCycleErrMess, setPatientCycleErrMess] = useState("");
  const [patientFormValues, setPatientFormValues] = useState({});
  const [patientCycleLoading, setPatientCycleLoading] = useState(false);
  const [selectedTemplateList, setSelectedTemplateList] = useState([]);
  const [addPhaseValues, setAddPhaseValues] = useState(null);
  const [orderBy, setOrderBy] = useState("");
  const [order, setOrder] = useState("");
  const [patientEditId, setPatientEditId] = useState(editSubjectId);
  const [editSubject, setEditSubject] = useState("");
  const [openAddPhaseModal, setOpenAddPhaseModal] = useState(false);
  const [visitFrequencies, setVisitFrequencies] = useState({});
  const [templateList, setTemplateList] = useState([]);
  const [initialPhaseModal, setInitialPhaseModal] = useState(false);
  const [getTemplateTypeIds, setTemplateTypeIds] = useState(null);
  const [selectFormType, setSelectFormType] = useState([]);
  const [formTypeListLoading, setformTypeListLoading] = React.useState(false);
  const [searchFilter, setSearchFilter] = React.useState("");
  const [page, setPage] = useState(1);
  const [maxPages, setMaxPages] = useState(null);
  const [isAddPhaseLoading, setIsAddPhaseLoading] = useState(false);
  const [isTrialInfoLoading, setIsTrialInfoLoading] = useState(false);
  const [isSwap, setIsSwap] = useState(false)
  const isSwapRef = useRef(null);
  const [gender, setGender] = useState('')
  const [count, setCount] = useState(1);
  const [isPhaseExist, setIsPhaseExist] = useState(null);
const [expand, setExpanded] = useState(null);
  const [openEditorDrawer, setOpenEditorDrawer] = useState(false);
  const [editorDrawerData, setEditorDrawerData] = useState([]);
  const [editorSearch, setEditorSearch] = useState("");
const handleExpand = (panelId) => {
  setExpanded(prev => (prev === panelId ? null : panelId));
};
useEffect(() => {
  setExpanded(null);
}, [activeTab]);

const patientEditRef = useRef({
    ...EditSubjectPhase,
    investigator_id: "",
    editor_id: ""
  });

  
  // CRITICAL FIX: Add state for better form management
  const [isSettingInitialValues, setIsSettingInitialValues] = useState(false);
  const [currentPiId, setCurrentPiId] = useState(null);
  const stateActive =searchParams.get("track_id");
  // Get the value of a specific query parameter
  const activeTrialId = stateActive || searchParams.get("phase_id");
    const debouncedSearch = useDebounce(tableFilters.searchData, 500);

  // FIXED: Patient Edit State with proper initialization
  const [patientEdit, setPatientEdit] = useState({
    ...EditSubjectPhase,
    investigator_id: "",
    editor_id: ""
  });

   useEffect(() => {
    patientEditRef.current = patientEdit;
  }, [patientEdit]);

  useEffect(() => {
    if (location.state?.openAddSubjectModal && phaseListDetails?.id) {
      handleOpenAddSubjectModal();
      navigate(location.pathname + location.search, { replace: true, state: {} });
    }
    if (location.state?.openAddPhaseModal && productDetails?.id) {
      handleAddPhaseModal();
      navigate(location.pathname + location.search, { replace: true, state: {} });
    }
  }, [location.state, phaseListDetails, productDetails]);
  const phaseTypeName = phaseListDetails?.phase_type_details?.name?.toLowerCase() || "";

  const investigatorLabel =
    phaseTypeName === "commercial" ? "HCP" : "Principal Investigator";

  const patientIdLabel =
    phaseTypeName === "trial" || phaseTypeName === "pms" ? "Subject ID" : "Patient ID";
const patientLabel =
    phaseTypeName === "trial" || phaseTypeName === "pms" ? "Subject " : "Patient ";
  const hospitalLabel =
    phaseTypeName === "trial" || phaseTypeName === "pms" ? "Site" : "Hospital";
  const firstNameLabel = phaseTypeName === "trial" ? "First Name Initial" : "First Name";
  const lastNameLabel = phaseTypeName === "trial" ? "Last Name Initial" : "Last Name";

  // Get the value of a specific query parameter
  const [subjectModelData, setSubjectModelData] = useState({
    title:`Add New ${patientLabel}`,
    editTitle: "Re-Assign PI/Editor",
    children: [
      {
        type: "input",
        name: "first_name",
        label: firstNameLabel,
        placeholder: `Enter ${firstNameLabel}`,
        IsRequired: true,
      },
      {
        type: "input",
        name: "last_name",
        label: lastNameLabel,
        placeholder: `Enter ${lastNameLabel}`,
        IsRequired: true,
      },
      {
        type: "dropdown",
        name: "gender",
        label: "Gender",
        placeholder: "Select gender",
        data: [],
        IsRequired: true,
      },
      {
        type: "dropdown",
        name: "investigator_id",
        label: investigatorLabel,
        placeholder: `Select ${investigatorLabel}`,
        data: [],
        IsRequired: true,
        onChange: (value) => {
          getEditorDropdown(value);
        }
      },
      {
        type: "dropdown",
        name: "editor_id",
        label: "Editor",
        placeholder: "Select Editor",
        data: [],
        IsRequired: false,
        dependency: "investigator_id"
      },
      {
        type: "dropdown",
        name: "disease_id",
        label: "Disease",
        placeholder: "Select disease",
        data: [],
        IsRequired: true,
      },
      {
        type: "date",
        name: "dob",
        label: "Date of Birth",
        placeholder: "Select Date",
        minDate: false,
        maxDate: new Date(),
        IsRequired: true,
      },
    ],
  });
useEffect(() => {
  if (!phaseTypeName) return;

  const isTrialOrPms = phaseTypeName === "trial" || phaseTypeName === "pms";
  const isCommercial = phaseTypeName === "commercial";

  setSubjectModelData((prev) => ({
    ...prev,
    title: isTrialOrPms ? "Add New Subject" : "Add New Patient",
    editTitle: prev.editTitle === "Re-Assign PI/Editor"
      ? isCommercial ? "Re-Assign HCP/Editor" : "Re-Assign PI/Editor"
      : prev.editTitle,
  }));
}, [phaseTypeName]);
  const handlePhaseTabChange = (phaseId) => {
    setActiveTab(phaseId);
    setCurrentpage(1);
  };
  const [modelData, setModelData] = useState({
    title: "Add Phase",
    children: [
      {
        type: "input",
        name: "phase_code",
        label: "Phase Code",
        placeholder: "Enter Phase Code",
        IsRequired: true,
      },
      {
        type: "input",
        name: "title",
        label: "Title",
        placeholder: "Enter Title",
        IsRequired: true,
      },
      {
        type: "dropdown",
        name: "phase_type",
        label: "Phase Type",
        placeholder: "Select Phase",
        IsRequired: true,
      },
      {
        type: "date",
        name: "phase_start_date",
        label: "Phase Start Date",
        placeholder: "Select Date",
        IsRequired: true,
      },
      {
        type: "input",
        name: "minimum_subjects",
        label: `Minimum no of ${patientLabel}`,
        placeholder: "Enter Number",
        IsRequired: true,
      },
      {
        type: "dropdown",
        name: "coordinating_PI_id",
        label: "Medical Expert ",
        placeholder: "Select Medical Expert",
        IsRequired: true,
      },
      {
        type: "description",
        name: "description",
        label: "Description",
        placeholder: "Description",
        IsRequired: true,
      },
    ],
  });
  useEffect(() => {
  if (!phaseTypeName) return;

  setModelData((prev) => ({
    ...prev,
    children: prev.children.map((child) =>
      child.name === "minimum_subjects"
        ? { ...child, label: `Minimum no of ${patientLabel}` }
        : child
    ),
  }));
}, [phaseTypeName]);
  const [openVisitNumberModel, setOpenVisitNumberModel] = useState(false);
  const [visitNumberModelData, setVisitNumberModelData] = useState({
    title: "Visit Frequency",
    children: [],
  });
  const [visitNumberIntialValue, setVisitNumberIntialValue] = useState({});
  const [exportModelData, setExportModelData] = useState({
    title: "Export Patients Data",
    children: [
      {
        type: "multidropdown",
        name: "formId",
        id: "selectFormDp",
        label: "Select Form",
        placeholder: "Select Form",
        data: [],
        IsRequired: true,
        showSelectAll: true,
      },
    ],
  });

  const [visitFrequencyModelData, setVisitFrequencyModelData] = useState({
    title: "Add visit frequency",
    children: [
      {
        type: "number",
        name: "template_type_ids",
        id: "template_type_ids",
        label: "",
        placeholder: "Enter visit frequency",
        data: [],
        IsRequired: true,
      },
    ],
  });

  const [defaultEditSubjectId, setDefaultEditSubjectId] = useState({
    title: `Edit ${patientLabel} Id`,
    editTitle: `Edit ${patientLabel} Id`,
    children: [
      {
        type: "input",
        name: "patientId",
        id: "patient_id",
        label:
          "Ensure that the entered Patient ID is same as received from ImmunoACT",
        placeholder: "Enter patient id",
        value: "",
        IsRequired: true,
      },
    ],
  });
useEffect(() => {
  setDefaultEditSubjectId({
    title: `Edit ${patientIdLabel}`,
    editTitle: `Edit ${patientIdLabel}`,
    children: [
      {
        type: "input",
        name: "patientId",
        id: "patient_id",
        label: `Ensure that the entered ${patientIdLabel} is same as received from ImmunoACT`,
        placeholder: `Enter ${patientIdLabel.toLowerCase()}`,
        value: "",
        IsRequired: true,
      },
    ],
  });
}, [patientIdLabel]);
  const [formQsList, setFormQsList] = useState([]);

  // Add this useEffect to handle editor selection when editors are loaded
  

useEffect(() => {
  isSwapRef.current = isSwap;
}, [isSwap]);

  useEffect(() => {
    if (isSwap && rowId && openAddSubjectModal) {
      const editorField = subjectModelData.children.find(child => child.name === "editor_id");
      if (editorField?.data && editorField.data.length > 0) {
        const currentEditorId = initialValues.editor_id || patientEdit.editor_id;
        const editorExists = editorField.data.some(editor => editor.id === currentEditorId);
        
        if (editorExists) {
          setInitialValues(prev => ({
            ...prev,
            editor_id: currentEditorId
          }));
          setPatientEdit(prev => ({
            ...prev,
            editor_id: currentEditorId
          }));
        }
      }
    }
  }, [subjectModelData, isSwap, rowId, openAddSubjectModal]);
  // FIXED: Improved useEffect for editor state synchronization
  /*useEffect(() => {

    // Don't run this effect while we're setting up initial values
    if (isSettingInitialValues) return;

    const editorField = subjectModelData.children.find(child => child.name === "editor_id");

    if (editorField?.data && patientEdit.editor_id) {
      // Check if the current editor_id exists in the available options
      const editorExists = editorField.data.some(editor => editor.id === patientEdit.editor_id);

      if (!editorExists && patientEdit.editor_id) {
        setPatientEdit(prev => ({
          ...prev,
          editor_id: ""
        }));
      }
    }
  }, [subjectModelData, patientEdit.editor_id, isSettingInitialValues]);*/
  useEffect(() => {  
    let newChildren = [];
    if (!rowId || !isSwap || subjectModelData?.editTitle == `Edit ${patientLabel}`) {
      newChildren = [
        {
          type: "input",
          name: "first_name",
          label: firstNameLabel,
          placeholder: `Enter ${firstNameLabel}`,
          IsRequired: true,
        },
        {
          type: "input",
          name: "last_name",
          label: lastNameLabel,
          placeholder: `Enter ${lastNameLabel}`,
          IsRequired: true,
        },
        {
          type: "dropdown",
          name: "gender",
          label: "Gender",
          placeholder: "Select gender",
          data: GenderList,
          IsRequired: true,
        },
        {
          type: "dropdown",
          name: "investigator_id",
          label:  investigatorLabel,
          placeholder: `Select ${investigatorLabel}`,
          data: pIList,
          IsRequired: true,
          onChange: (value) => {
            getEditorDropdown(value);
          }
        },
        {
          type: "dropdown",
          name: "editor_id",
          label: "Editor",
          placeholder: "Select Editor",
          data: [],
          IsRequired: false,
          dependency: "investigator_id"
        },
        {
          type: "dropdown",
          name: "disease_id",
          label: "Disease",
          placeholder: "Select disease",
          data: diseaseList,
          IsRequired: true,
          disabled: rowId && subjectModelData?.editTitle === "Edit Patient",
        },
        {
          type: "date",
          name: "dob",
          label: "Date of Birth",
          placeholder: "Select Date",
          minDate: false,
          maxDate: new Date(),
          IsRequired: true,
        },
      ];
    } else {
      newChildren = [
        {
          type: "dropdown",
          name: "investigator_id",
          label: investigatorLabel,
          placeholder: `Select ${investigatorLabel}`,
          data: pIList,
          IsRequired: true,
          onChange: (value) => {
            getEditorDropdown(value);
          }
        },
        {
          type: "dropdown",
          name: "editor_id",
          label: "Editor",
          placeholder: "Select Editor",
          data: [],
          IsRequired: false,
        },
      ];
    }

    setSubjectModelData((prevState) => ({
      ...prevState,
      children: newChildren,
    }));
  }, [editorList, rowId, isSwap, pIList, diseaseList]);

  const SumbitAssignAllPiAndEditor = (action) => {
    const selectedUser = subjectModelData.children
  .find(child => child.name === "editor_id")
  ?.data?.find(item => item.id === sumbitPiEditorValues?.editor_id);
    setOpenAssignForAllModal(false);
    if (action === "YES") {
      handleUpdatePiEditor({
        investigator_id: sumbitPiEditorValues?.investigator_id,
        editor_id: sumbitPiEditorValues?.editor_id,
        phase_id: phaseListDetails?.id,
         role_slug: selectedUser?.role,
      });
    } else if (action === "NO") {
      handleUpdatePiEditor({
        investigator_id: sumbitPiEditorValues?.investigator_id,
        editor_id: sumbitPiEditorValues?.editor_id,
        subject_id: rowId,
        phase_id: phaseListDetails?.id,
         role_slug: selectedUser?.role,
      });
    }
  };

  const handleTemplateList = (data) => {
    setSelectedTemplateList(data);
  };

  React.useEffect(() => {
    if (Object.keys(sumbitPiEditorValues).length > 0) {
      setOpenAddSubjectModal(false);
      setTimeout(() => {
        setOpenAssignForAllModal(true);
      }, 200);
    }
  }, [sumbitPiEditorValues]);

 const handleOpenAssignPiAndEditorModal = (values) => {
  const selectedUser = subjectModelData.children
    .find(child => child.name === "editor_id")
    ?.data?.find(item => item.id === values?.editor_id);
  
  // Fix: Find the subject data using internalData
  const subData = subjectListData.find(
    (sub) => sub.internalData.rowId === rowId
  )?.internalData.originalData;
  // Check if subData exists before accessing its properties
  if (subData && Object.keys(subData).length > 0) {
    // Check if both editorDetails and investigatorDetails exist and are not empty
    const hasEditorDetails = subData?.editorDetails && Object.keys(subData.editorDetails).length > 0;
    const hasInvestigatorDetails = subData?.investigatorDetails && Object.keys(subData.investigatorDetails).length > 0;
    
    if (hasEditorDetails && hasInvestigatorDetails) {
      handleUpdatePiEditor({
        investigator_id: values?.investigator_id,
        editor_id: values?.editor_id,
        subject_id: rowId,
        phase_id: phaseListDetails?.id,
        role_slug: selectedUser?.role,
      });
    } else {
      setSubmitPiEditorValues(values);
    }
  } else {
    // If subData is not found, still proceed with the update
    // This handles edge cases where data might not be fully loaded
    handleUpdatePiEditor({
      investigator_id: values?.investigator_id,
      editor_id: values?.editor_id,
      subject_id: rowId,
      phase_id: phaseListDetails?.id,
      role_slug: selectedUser?.role,
    });
  }
};
useEffect(() => {
  if (phaseListDetails?.phase_type_details) {
    setSubjectData(prev => ({
      ...productDetailsData(phaseListDetails.phase_type_details),
      rows: prev.rows,
    }));
  }
}, [phaseListDetails?.phase_type_details?.id]);
  const handleNavigateToDetails = useCallback((row) => {
  const UpdatedNavigationArray = Array.isArray(location.state)
    ? [...location.state]
    : [];
    UpdatedNavigationArray?.push({
      name: "Patient Details",
      path: `${location.pathname}/patient-details/${row[row.length - 1]}`,
    });
    navigate(`patient-details/${row[row.length - 1]}`, {
      state: UpdatedNavigationArray,
    });
  }, [location]);

  const handleEdit = useCallback(() => {
      const UpdatedNavigationArray = Array.isArray(location.state)
    ? [...location.state]
    : [];
    UpdatedNavigationArray?.push({
      name: "Edit Details",
      path: `${location.pathname}/edit-trial-details/${phaseListDetails?.id}`,
    });
    navigate(`edit-trial-details/${phaseListDetails?.id}`, {
      state: UpdatedNavigationArray,
    });
  }, [phaseListDetails?.id, location]);

  const handleDelete = () => {
    setOpenDeleteModal(true);
  };

  const handleOpenTrailPhaseModal = () => {
    setOpenAddTrailPhaseModal(true);
  };

  const handleAddPhaseModal = () => {
    if (phaseListData?.length > 0) {
      setIsAddPhaseLoading(false);
      setIsTrialInfoLoading(false);
    } else {
      setIsAddPhaseLoading(true);
      setIsTrialInfoLoading(true);
    }
    setOpenAddPhaseModal(true);
    fetchData();
  };

 const handleOpenAddSubjectModal = async () => {
  setIsSwap(false);
  isSwapRef.current = false;
  
  if (phaseListDetails?.investigator_details?.investigator_id?.length == 0) {
    notify.error("You can't add patient until PI is not added for phase !");
    return;
  }

  setInitialValues({
    investigator_id: "",
    editor_id: "",
  });
  setRowId(null);
  setOpenAddSubjectModal(true);

  setPatientEdit({
    ...EditSubjectPhase,
    investigator_id: "",
    editor_id: ""
  });

  // Reset editor dropdown data
  setSubjectModelData((prevState) => ({
    ...prevState,
    children: prevState.children.map((child) =>
      child.name === "editor_id"
        ? { 
            ...child, 
            data: [],
            placeholder: phaseTypeName === "commercial" ? "Select HCP first" : "Select PI first"
          }
        : child
    ),
  }));

  // Do NOT auto-select PI or editor
  // The user should select PI first, then editor dropdown will populate
};
  const handleVisitFrequency = (values) => {
    setVisitFrequencies(values);
  };

  const handleAddVisitNumber = async (values) => {
    resetSortFilter();

    const result = selectFormType.map((item) => ({
      type: "number",
      name: `${item.id}`,
      label: `${item.name}`,
      placeholder: "Enter Number",
      IsRequired: true,
      minValueNumber: 1,
    }));

    const visitIntialVal = {};

    result?.forEach((item) => {
      visitIntialVal[item.name.toString()] = 1;
    });
    setVisitNumberIntialValue(visitIntialVal);

    setVisitNumberModelData((prevData) => ({
      ...prevData,
      children: result,
    }));

    const normalizeArrayField = (field) => (field ? [field] : []);

    const updatedValues = {
      ...values,
      qa_ids: normalizeArrayField(values.qa_ids),
      template_type_ids: visitFrequencies.template_type_array,
      manager_ids: normalizeArrayField(values.manager_ids),
      form_template_ids: normalizeArrayField(values.form_template_ids),
      phase_start_date: moment(values.phase_start_date).format("MM/DD/YYYY"),
      product_id: id,
      status: 1,
    };

    try {
      setIsAddPrLoading(true);
      const response = await PhaseApi.addPhase(updatedValues);
      await getPhaseList();
      notify.success(response.message || "Phase added successfully");
      setInitialPhaseModal(false);
      setOpenAddTrailPhaseModal(false);
      setIsAddPhaseLoading(false);
      setIsTrialInfoLoading(false);
    } catch (error) {
      notify.error(error?.message || error || "Failed to add phase");
    } finally {
      setIsAddPrLoading(false);
    }
  };

  const addVisitTypeNumValidationSchema = (dynamicFields) => {
    const schema = {};
    if (dynamicFields?.children?.length) {
      dynamicFields.children.forEach((field) => {
        if (field.type === "number") {
          schema[field.name] = Yup.number()
            .required(`${field.label} is required`)
            .min(1, `${field.label} must be greater than 0`)
            .integer(`${field.label} must be an integer`);
        }
      });
    }
    return Yup.object().shape(schema);
  };

  const handleAddPhase = async (values) => {
    const result = formTemplateDropdownList
      ?.filter((item) => selectedTemplateList.includes(item.id.toString()))
      .map((item) => ({
        type: "number",
        name: `${item.id}`,
        label: `${item.name}`,
        placeholder: "Enter Number",
        IsRequired: true,
        minValueNumber: 1,
      }));

    const visitIntialVal = {};

    result?.forEach((item) => {
      visitIntialVal[item.name.toString()] = 1;
    });
    setVisitNumberIntialValue(visitIntialVal);

    setVisitNumberModelData((prevData) => ({
      ...prevData,
      children: result,
    }));

    const normalizeArrayField = (field) => (field ? [field] : []);
    const updatedValues = {
      ...values,
      qa_ids: normalizeArrayField(values.qa_ids),
      template_type_ids: visitFrequencies,
      manager_ids: normalizeArrayField(values.manager_ids),
      form_template_ids: normalizeArrayField(values.form_template_ids),
      phase_start_date: moment(values.phase_start_date).format("MM/DD/YYYY"),
      product_id: id,
      status: 1,
    };
    setAddPhaseValues(updatedValues);
  };

  const handleAddSubject = async (values, confirmation) => {
    SetIsAddSubjectLoading(true);
    setPatientFormValues(values);
    const formData = new FormData();
    formData.append("first_name", values.first_name?.trim());
    formData.append("last_name", values.last_name?.trim());
    if (values.upload_file) {
      if (values.upload_file instanceof FileList) {
        for (let i = 0; i < values.upload_file.length; i++) {
          formData.append("files", values.upload_file[i]);
        }
      } else {
        formData.append("files", values.upload_file);
      }
    }
    formData.append(
      "gender",
      GenderList?.find((op) => op?.id == values.gender)?.name
    );
    formData.append("dob", moment(values.dob).format("MM/DD/YYYY"));
    formData.append("disease_id", values.disease_id);
    formData.append("phase_id", phaseListDetails?.id);
    formData.append("phase_code", phaseListDetails?.phase_code);
    formData.append("phase_title", phaseListDetails?.title);
    formData.append("investigator_id", values.investigator_id);
    formData.append("editor_id", values.editor_id);
    formData.append("product_id", id);
    formData.append("addCycle", confirmation || false);

    try {
      const response = await SubjectApi.addSubject(formData);
      await getSubjectList();
      getPhaseDetails(activeTab);
      notify.success(response.message || "Patient Added Successfully");
      setOpenAddSubjectModal(false);
    } catch (error) {
      const addCycleError = error?.errors?.find((obj) =>
        Object.prototype.hasOwnProperty.call(obj, "addCycle")
      );

      if (addCycleError) {
        setPatientCycleErrMess(addCycleError?.addCycle);
        setPatientCycleConfirm(true);
      } else {
        notify.error(error?.message || error || "Failed to Add Patient");
      }
    } finally {
      SetIsAddSubjectLoading(false);
      if (confirmation) {
        setPatientCycleConfirm(false);
      }
    }
  };

  const handlePhaseSearch = (value) => {
    resetSortFilter();
    if (value !== " ") {
      getPhaseList(value);
    }
  };

  async function getPhaseList(search = "", limit = 100, page = 1) {
    setLoading(prev => ({ ...prev, phaseList: true, page: true }));
    try {
      const res = await PhaseApi.getPhaseList(id, search, limit, page);
      setPhaseListData(res.data || []);
      if (activeTrialId) {
        setActiveTab(activeTrialId);
      } else {
        setActiveTab(res?.data && res?.data[0]?.id);
      }
    } catch (error) {
      notify.error(error);
    } finally {
      setLoading(prev => ({ ...prev, phaseList: false, page: false }));
    }
  }

  const getProductDetails = async () => {
    try {
      const res = await ProductApi.getProductDetails(id);
      setProductDetails(res?.data);
    } catch (error) {
            notify.error(error?.message)
    }
  };

  useEffect(() => {
    getPhaseList();
    getProductDetails();
  }, []);

  function isArrayInArray(data, ndata) {
    return data.every((element) => ndata.includes(+element));
  }

  const handleShowAddSubjectButton = (data) => {
    if (data?.form_details) {
      let formTempIds = data?.template_type_ids.map((v) => +v);
      const showButton = data?.form_details.map((value) => {
        if (value?.is_approved !== false) {
          return value.type.id;
        }
      });
      const IsEqual = isArrayInArray(formTempIds, showButton);
      setDisableButton(!IsEqual);
    }
  };

  async function getPhaseDetails(activeTab) {
    if (!activeTab) return;

    setLoading(prev => ({ ...prev, phaseDetail: true }));
    try {
      const res = await PhaseApi.getPhaseListDetails(activeTab);
      handleShowAddSubjectButton(res?.data);
      setPhaseListDetails(res?.data || []);
      getSubjectModelData(res?.data);
      dispatch(setPhaseDetail(res?.data));
      if (res.status === 204) {
        setIsPhaseExist(true)
      } else {
        setIsPhaseExist(false)
      }
    } catch (error) {
      notify.error(error);
    } finally {
      setLoading(prev => ({ ...prev, phaseDetail: false }));
    }
  }

  const fetchData = async () => {
    if (formTypeListLoading) return;

    setformTypeListLoading(true);

    try {
      const response = await PhaseApi.getTemplateTypeList(
        page,
        10,
        searchFilter
      );

      if (response.data) {
        setTemplateList((prev) => {
          if (page > 1) {
            return [...prev, ...response.data];
          } else {
            return response.data;
          }
        });

        setMaxPages(
          Math.ceil(
            response.page_details.no_of_records / response.page_details.limit
          )
        );
      }
    } catch (error) {
      notify.error(error.message || "An error occurred while fetching data.");
    } finally {
      setformTypeListLoading(false);
    }
  };

  React.useEffect(() => {
    if (page === 1 || page > 1) {
      fetchData();
    }
  }, [page]);

  React.useEffect(() => {
    if (count === 5) {
      setPage((prevPage) => prevPage + 1);
    }
  }, [count]);

  const loadMoreData = () => {
    if (page < maxPages) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  useEffect(() => {
    setEditorId(null);
    setPiID(null);
    if (activeTab) {
      getPhaseDetails(activeTab);
    }
  }, [activeTab]);

  useEffect(() => {
    if (phaseListDetails?.id && debouncedSearch !== undefined) {
      getSubjectList();
    }
  }, [currentPage, debouncedSearch, phaseListDetails, piId, editorId, orderBy, order]);

  const getSubAdminDropdown = async (id) => {
    try {
      return await SubAdminApi.getSubAdminDropdown(id);
    } catch (error) {
      notify.error(error);
    }
  };

  const getPhaseTypeDropDown = async () => {
    try {
      return await PhaseApi.getPhaseTypeDropDown();
    } catch (error) {
      notify.error(error);
    }
  };

  const getSubjectModelData = async (phaseRes) => {
    try {
      let desRes = await DiseaseManagementApi.getDiseaseManagementData();
      setDiseaseList(desRes?.data);


      setSubjectModelData((prevState) => ({
        ...prevState,
        children: prevState.children.map((child) =>
          child.name === "disease_id"
            ? { ...child, data: desRes?.data }
            : child.name == "investigator_id"
              ? {
                ...child,
                data: phaseRes?.investigator_details?.principal_investigator ?? [],
              }
              // : child.name == "editor_id"
              //   ? {
              //     ...child,
              //     data: availableEditors,
              //     placeholder: availableEditors.length > 0 ? "Select Editor" : "No editors available"
              //   }
                : child.name == "gender"
                  ? { ...child, data: GenderList }
                  : child
        ),
      }));

    } catch (error) {
      notify.error(error);
    }
  };

  // Function to get Editor Dropdown
const getEditorDropdown = async (Pi_id, isEditMode = false) => {
  try {
    if (isEditMode) {
      setInitialValues(prev => ({ ...prev, investigator_id: Pi_id }));
    }

    if (Pi_id) {
      let res = await ProductApi.subadminDropDown(
        5,
        Pi_id,
        phaseListDetails?.id
      );
      let transformedData = res?.data || [];
      
      if (isSwapRef.current) {
        transformedData = transformedData.map(item => ({
          ...item,
          name: `${item.name} (${item.role})`,
          label: `${item.name} (${item.role})`
        }));
      } else {
        transformedData = transformedData.filter(
          item => item.role === "editor"
        );
      }
      const currentPhaseTypeName = phaseListDetails?.phase_type_details?.name?.toLowerCase() || "";
      const isCommercial = currentPhaseTypeName === "commercial";
      setSubjectModelData((prevState) => ({
        ...prevState,
        children: prevState.children.map((child) =>
          child.name === "editor_id" ? {
            ...child,
            data: transformedData,
            placeholder: transformedData.length > 0 
              ? "Select Editor" 
              : isSwapRef.current 
                ?  `No editors available for this ${isCommercial ? "HCP" : "PI"}`
                : `No team members available for this ${isCommercial ? "HCP" : "PI"}`
          } : child
        ),
      }));

      // Only reset editor_id if NOT in edit mode and NOT swapping
      if (!isEditMode && !rowId) {
        setPatientEdit(prev => ({
          ...prev,
          editor_id: ""
        }));
      }
    } else {
      // When Pi_id is empty (when PI selection is cleared)
      setSubjectModelData((prevState) => ({
        ...prevState,
        children: prevState.children.map((child) =>
          child.name === "editor_id"
            ? { 
                ...child, 
                data: [], 
                placeholder: "Select PI first" 
              }
            : child
        ),
      }));
      
      // Clear editor selection when PI is cleared
      setPatientEdit(prev => ({
        ...prev,
        editor_id: ""
      }));
    }
  } catch (error) {
    notify.error(error?.message || "Failed to load editors");

    setSubjectModelData((prevState) => ({
      ...prevState,
      children: prevState.children.map((child) =>
        child.name === "editor_id"
          ? {
              ...child,
              placeholder: "Error loading editors",
              data: []
            }
          : child
      ),
    }));
  }
};

  const getFormTemplateDropDown = async () => {
    try {
      return await api.formTemplateDropDown();
    } catch (error) {
      notify.error(error);
    }
  };

  const getEditorForSubjectSubAdmin = async (value) => {
    try {
      return await SubAdminApi.getEditorForSubjectSubAdmin(
        value,
        phaseListDetails?.id,""
      );
    } catch (error) {
      notify.error(error);
    }
  };

  useEffect(() => {
    const fetchSubAdminDropdownData = async () => {
      const results = await Promise.allSettled([
        getSubAdminDropdown(2),
        getSubAdminDropdown(3),
        getSubAdminDropdown(4),
        getPhaseTypeDropDown(),
        getFormTemplateDropDown(),
      ]);

      results.forEach((result, index) => {
        if (result.status === "fulfilled") {
          const data = result.value?.data || [];
          switch (index) {
            case 0:
              dispatch(setPICoordinator(data));
              break;
            case 1:
              dispatch(setIAQA(data));
              break;
            case 2:
              dispatch(setTrialManager(data));
              break;
            case 3:
              dispatch(setPhaseType(data));
              break;
            case 4:
              dispatch(setFormTemplateDropList(data));
              break;
            default:
              break;
          }
        }
      });
    };
    fetchSubAdminDropdownData();
  }, []);

  useEffect(() => {
    if (phaseListDetails?.id) {
      if (
        tableFilters?.searchData[tableFilters?.searchData?.length - 1] != " "
      ) {
        setLoading(true);
        getSubjectList();
      }
    }
  }, [currentPage, tableFilters, phaseListDetails, piId, editorId]);

  // Update the PI list to use data from phase details
  useEffect(() => {
    if (phaseListDetails?.id) {
      // Set PI list from phase details
      const principalInvestigators = phaseListDetails?.investigator_details?.principal_investigator || [];
      setPIList(principalInvestigators);
      // Set editor list from phase details
      // const availableEditors = phaseListDetails?.editor_details || [];
      // setEditorList(availableEditors);

    }
    const fetchEditorData = async () => {
      if (!phaseListDetails?.id) return;
      const results = await Promise.allSettled([
        getEditorForSubjectSubAdmin(2),
        getEditorForSubjectSubAdmin(5),
      ]);

      results?.forEach((result, index) => {
        if (result.status === "fulfilled") {
          const data = result.value?.data || [];
          switch (index) {
            case 0:
              setPIList(data);
              break;
            case 1:
              setEditorList(data);
              break;
            default:
              break;
          }
        }
      });
    };

    fetchEditorData();
  }, [phaseListDetails]);

  useEffect(() => {
    if (modelData?.children) {
      const mapedSelectDrop = modelData.children.map((item) => {
        switch (item.name) {
          case "qa_ids":
            return { ...item, data: iAQA };
          case "coordinating_PI_id":
            return { ...item, data: pICoordinator };
          case "manager_ids":
            return { ...item, data: trialManager };
          case "phase_type":
            return { ...item, data: phaseType };
          case "form_template_ids":
            return {
              ...item,
              data: formTemplateDropList?.map((item) => ({
                id: item.id,
                name: item.title,
              })),
            };
          default:
            return item;
        }
      });

      setModelData((prevModelData) => ({
        ...prevModelData,
        children: mapedSelectDrop,
      }));
    }
  }, [iAQA, trialManager, pICoordinator]);

  const GetMatchedKey = (key) => {
    switch (key.trim().toLowerCase()) {
      case "s.no": {
        return "created_at";
      }
      case "patient id": {
        return "patient_id";
      }
      case "patient name": {
        return "name";
      }
      case "patient status": {
        return "life_status";
      }
      case "last recorded visit": {
        return "last_visit_type";
      }
      case "investigator": {
        return "investigator";
      }
      case "phase": {
        return "phase_name";
      }
      case "appointment completed": {
        return "appointmentCount";
      }
      case "editor": {
        return "editor";
      }
      case "cycle no.": {
        return "cycle";
      }
      default:
        return "";
    }
  };

 async function getSubjectList() {
  setLoading(prev => ({ ...prev, subjectList: true, table: true }));
  const sortBy = GetMatchedKey(orderBy);

  try {
    const res = await SubjectApi.getSubjectList(
      phaseListDetails?.id,
      currentPage,
      10,
      debouncedSearch,
      editorId,
      piId,
      "",
      "",
      sortBy,
      order
    );    
    let convertedData = convertSubjectData(
      res?.data || [],
      currentPage,
      res?.page_details,
      order
    );    
    let rowData = convertedData.map(item => item.displayData);
    setSubjectListData(convertedData);
    setSubjectData((prev) => ({
      ...prev,
      rows: [...rowData],
    }));
    setTotalPage(
      Math.ceil(res?.page_details?.no_of_records / res?.page_details?.limit)
    );
    setCurrentpage(res?.page_details?.page);
    
    setLoading(prev => ({ ...prev, subjectList: false, table: false }));

  } catch (error) {
    notify.error(error);
    setLoading(prev => ({ ...prev, subjectList: false, table: false }));
  }
}

  const handleDeletePhase = async () => {
    try {
      setIsDeleteLoading(true);
      const response = await PhaseApi.deletePhase(phaseListDetails?.id);
      notify.success(response?.message);
      await getPhaseList();
      setOpenDeleteModal(false);
    } catch (error) {
      notify.error(error || error?.message || "Failed to delete phase");
    } finally {
      setIsDeleteLoading(false);
    }
  };

  const handlePagination = async (value) => {
    setCurrentpage(value);
    // Auto-scroll to patient listing after pagination change
    setTimeout(() => {
      scrollToPatientListing();
    }, 100);
  };

  const handleTableFilters = (e) => {
    setTablesFilters({ ...tableFilters, searchData: e });
    setCurrentpage(1);
  };

  const handleDropDownChange = (e, id) => {
    setCurrentpage(1);
    if (id === "selectPI") {
      setPiID(e.target.value);
    } else if (id === "editorList") {
      setEditorId(e.target.value);
    }
  };

  const getGender = async (isGenderName) => {
    return new Promise((resolve) => {
      switch (isGenderName) {
        case "Male":
          setGender(1);
          resolve(1);
          break;
        case "Female":
          setGender(2);
          resolve(2);
          break;
        case "Others":
          setGender(3);
          resolve(3);
          break;
        default:
          resolve(null);
          break;
      }
    });
  };

  // @info : Function to change gender value to string to send into the payload 
  const changeGenderPayload = (value) => {
    let genderTransform = 'Male';

    switch (value) {
      case 1:
        genderTransform = 'Male';
        break;
      case 2:
        genderTransform = 'Female';
        break;
      case 3:
        genderTransform = 'Others';
        break;
    }

    return genderTransform;
  }

  const handleEditSubjectid = (row) => {
    setRowId(row[row.length - 1]);
    setOpenEditSubjectIdModal(true);
    const subData = subjectListData.find( //@info Required to fetch correct patientId(patient_id)
      (sub) => sub?.internalData?.rowId === row[row.length - 1]
    );
    setEditSubject(subData?.internalData?.originalData?.id); //@info Required to fetch correct (subject_id)
    setPatientEditId((prevState) => ({
      ...prevState,
      patientId: subData?.internalData?.patient_id,
    }));
  };

  // FIXED: Improved handleEditSubject function
  const handleEditSubject = async (row) => {
    setIsSwap(false);
    isSwapRef.current= false;
    setIsEditFormLoading(true);

    try {
      const rowId = row[row.length - 1];
      setRowId(rowId);
const patientData = subjectListData.find(
  (patient) => patient.internalData.rowId === rowId
)?.internalData.originalData;

      setSubjectModelData((prev) => ({
        ...prev,
        editTitle: `Edit ${patientLabel}`
      }));

      const genderValue = await getGender(patientData?.gender);
      const updatedPatientEdit = {
        first_name: patientData?.first_name || "",
        last_name: patientData?.last_name || "",
        gender: genderValue,
        dob: patientData?.dob ? parseToDate(patientData.dob) : "",
        editor_id: patientData?.editorDetails?.id || "",
        investigator_id: patientData?.investigatorDetails?.id || "",
        disease_id: patientData?.disease_id || "",
        phase_id: phaseListDetails?.id || "",
        phase_code: phaseListDetails?.phase_code || "",
        phase_title: phaseListDetails?.title || "",
        addCycle: patientData?.cycle || "",
      };
      setPatientEdit(updatedPatientEdit);
      patientEditRef.current = updatedPatientEdit;

      await new Promise(resolve => setTimeout(resolve, 50));

      setOpenAddSubjectModal(true);
      // Load editors for the specific investigator
      if (patientData?.investigatorDetails?.id) {
        await getEditorDropdown(patientData.investigatorDetails.id, true);
      } 
      // Additional small delay to ensure everything is rendered
      await new Promise(resolve => setTimeout(resolve, 100));

    } catch (error) {
      notify.error("Failed to load patient data for editing")
    } finally {
      setIsEditFormLoading(false);
    }
  };

  const handleEditSubjectSubmit = async (values) => {
     setIsEditFormLoading(true); 
    try {
      const payload = { ...values };
      payload.gender = changeGenderPayload(values?.gender);
      const response = await SubjectApi.editPatient(payload, rowId);

      getPhaseDetails(activeTab);
      notify.success(response.message || "Patient Edited Successfully");
      await getSubjectList();
      setOpenAddSubjectModal(false);
    } catch (error) {
      notify.error(error.message || error || "Failed to Edit Patient");
    }
    finally {
     setIsEditFormLoading(false); 
  }
  }

  const handleSwapButton = (row) => {
  setIsSwap(true);
  isSwapRef.current = true;
  const currentPhaseTypeName = phaseListDetails?.phase_type_details?.name?.toLowerCase() || "";
  setSubjectModelData((prev) => ({ 
    ...prev, 
    editTitle: currentPhaseTypeName === "commercial" ? "Re-Assign HCP/Editor" : "Re-Assign PI/Editor"
  }));
  
  const rowId = row[row.length - 1];
  setRowId(rowId);
  
  // Use internalData to find the subject
  const subData = subjectListData.find(
    (sub) => sub.internalData.rowId === rowId
  )?.internalData.originalData;
  
  if (subData?.investigatorDetails?.id) {
    getEditorDropdown(subData.investigatorDetails.id, true);
    setInitialValues({
      investigator_id: subData.investigatorDetails.id || "",
      editor_id: subData.editorDetails?.id || "",
    });
  } else {
    // If no investigator found, just set empty values
    setInitialValues({
      investigator_id: "",
      editor_id: "",
    });
  }
  
  setOpenAddSubjectModal(true);
};

  const handleUpdatePiEditor = async (data) => {
    setAssignPiLoader(true);
    try {
      const response = await ProductApi.updatePiEditor(data);
      setOpenAddSubjectModal(false);
      getSubjectList();
      notify.success(response?.message);
    } catch (error) {
      notify.error(error || error.message || "Failed to delete phase");
    } finally {
      setSubmitPiEditorValues({});
      setAssignPiLoader(false);
    }
  };

  const handleExportButton = () => {
    if (phaseListDetails && phaseListDetails?.form_details?.length > 0) {
      const multiSelectData = phaseListDetails?.form_details?.map((item) => ({
        id: item?.id,
        name: item?.type?.name,
      }));
      setExportType("csv");

      setExportModelData((prevState) => ({
        ...prevState,
        title: "Export CSV",
        children: prevState.children.map((child, index) =>
          index === 0 ? { ...child, data: multiSelectData || [] } : {}
        ),
      }));
      setOpenExportModal(true);
    } else {
      notify.error("No Form Assigned");
    }
  };

  const organizeDataByKey = (arr) => {
    const organized = arr.reduce((acc, str) => {
      const [formId, questionId] = str.split("__-=");
      if (!acc[formId]) {
        acc[formId] = {
          id: formId,
          questions: [],
          ...formId  == 'prescreen' ? {formLabels: extraFormOptions}: {}
        };
      }

      acc[formId].questions.push(questionId);

      return acc;
    }, {});

    return Object.values(organized);
  };

const handleExcelExportButton = () => {
    if (phaseListDetails && phaseListDetails?.form_details?.length > 0) {
      const multiSelectData = phaseListDetails?.form_details?.map((item) => ({
        id: item?.id,
        name: item?.type?.name,
      }));
      const final = [...[{id:'prescreen',name:'Pre-Screening'}],...multiSelectData]
      setExportType("excel");
      setExportModelData((prevState) => ({
        ...prevState,
        title: "Export Excel (with Dropdowns)",
        children: prevState.children.map((child, index) =>
          index === 0 ? { ...child, data: final || [] } : {}
        ),
      }));
      setOpenExportModal(true);
    } else {
      notify.error("No Form Assigned")
    }
  };


  // Function for handle update patient id
  const handleSavePatientId = async (data) => {
    setEditIdLoading(true);
    const formData = {
      subject_id: editSubject,
      patient_id: data.patientId,
    };

    SubjectApi.editPatientId(formData)
      .then((res) => {
        if (res.status == 200 && res.success == true) {
          setEditIdLoading(false);
          setOpenEditSubjectIdModal(false);
          notify.success("Patient Id Updated Successfully!");
        } else {
          setEditIdLoading(false);
          notify.error(res?.message);
        }

        getSubjectList();
      })
      .catch((e) => {
        setEditIdLoading(false);
        setOpenEditSubjectIdModal(false);
        notify.error("Patient Id Updatedtion Failed, Try later!");
      });
  };

  const handleExportModel = async (val) => {
    const updatedformQsList = Array.isArray(formQsList)
      ? formQsList.map((item) => ({
        ...item,
        questions: Array.isArray(item.questions)
          ? item.questions.map((el) => el.id)
          : [],
      }))
      : [];

    try {
      setExportLoading(true);
      const res = await PhaseApi.exportFormCsv(
        phaseListDetails?.id,
        val?.formId?.length === 1
          ? updatedformQsList
          : organizeDataByKey(val?.questionId)
      );
      if (res?.data && !isEmpty(res?.data)) {
        const csvData = jsonToCsv(res?.data);
        downloadCsv(
          csvData,
          `${phaseListDetails?.product_details?.name}_${phaseListDetails?.title}_${moment().format('YYYY-MM-DD')}.csv`
        );
        setOpenExportModal(false);
      } else {
        notify.error("No Patient Data Found");
      }
    } catch (error) {
      notify.error(error);
      setOpenExportModal(false);
    } finally {
      setExportLoading(false);
    }
  };


 const handleExcelExportModel = async (val) => {
    const updatedformQsList = Array.isArray(formQsList)
      ? formQsList.map((item) => ({
        ...item,
        questions:  Array.isArray(item.questions)
          ? item.questions.map((el) => el.id)
          : [],
      }))
      : [];

    try {
      setExportLoading(true);
      const res = await PhaseApi.exportFormCsv(
        phaseListDetails?.id,
        val?.formId?.length === 1
          ? updatedformQsList
          : organizeDataByKey(val?.questionId)
      );
      if (res?.data && !isEmpty(res?.data)) {
        try {
          exportToExcelWithDropdowns(
            res?.data,
            `${phaseListDetails?.product_details?.name}_${phaseListDetails?.title}_${moment().format('YYYY-MM-DD')}.xlsx`
          );
          setOpenExportModal(false);
          notify.success("Excel exported successfully with dropdowns")
          // dispatch(
          //   setSnackbar({
          //     value: true,
          //     message: "Excel exported successfully with dropdowns",
          //     color: "success",
          //   })
          // );
        } catch (excelError) {
          console.error("Excel Generation Error:", excelError);
          throw excelError;
        }
      } else {
             notify.error("No PAtient Data Found")

      }
    } catch (error) {
      notify.error("No appointment answer found")
      setOpenExportModal(false);
      console.log("Export Excel Error:", error);
    } finally {
      setExportLoading(false);
    }
  };
  const handleExportSelect = async (val, name) => {
    try {
      if (name === "formId") {
        if (val?.length >= 1) {
          const res = await PhaseApi.getQuestionsByFormTemplate(
            phaseListDetails?.id,
            val
          );

           let prescrn = []
          if(val.includes('prescreen')){
            prescrn = [{
                id: 'prescreen',
                title: 'Pre-Screening Form',
                questions: extraFormOptions,
                formLabels: extraFormOptions
            }] 
          }

          if (val?.length === 1) {
            setFormQsList([...prescrn,...res.data || []]);
          }
         
          if (val?.length > 1) {
            const finalRes = [...prescrn,...res.data || []]
            if (finalRes?.length > 0) {
              const transformedData = finalRes?.map((form) => ({
                ...form,
                questions: form.questions?.map((question) => ({
                  ...question,
                  id: `${form.id}__-=${question.id}`,
                })),
              }))

              setExportModelData((prevState) => {
                const updatedChildren = prevState.children.map((child) =>
                  child.name === "questionId"
                    ? { ...child, data: transformedData, disabled: false }
                    : child
                );
                if (
                  !prevState.children.some(
                    (child) => child.name === "questionId"
                  )
                ) {
                  updatedChildren.push({
                    type: "multidropdown",
                    name: "questionId",
                    label: "Select Questions",
                    placeholder: "Select Questions",
                    data: transformedData,
                    IsRequired: true,
                    disabled: false,
                    showSelectAll: true,
                  });
                }
                return {
                  ...prevState,
                  children: updatedChildren,
                };
              });
            }
          }
        }
        if (val?.length <= 1) {
          setExportModelData((prevState) => ({
            ...prevState,
            children: prevState.children.filter(
              (child) => child.name !== "questionId"
            ),
          }));
        }
      }
    } catch (error) {
      console.error("Error handling export select:", error);
    }
  };

  const handlePatientCycleConfrim = (confirmation) => {
    if (!confirmation) {
      setPatientFormValues({});
      setPatientCycleConfirm(false);
      setOpenAddSubjectModal(false);
      notify.error("Duplicate record not created.");
      return;
    }
    setPatientCycleLoading(true);
    handleAddSubject(patientFormValues, confirmation);
    setPatientFormValues({});
    setPatientCycleLoading(false);
  };

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const resetSortFilter = () => {
    if (order == "desc") {
      setOrder("desc");
    }
    if (orderBy) {
      setOrderBy("");
    }
  };

  const handleCellClick = (row, columnIndex) => {
    const rowIndex = getRowIndex(row);
    if (!subjectListData || !subjectListData[rowIndex]) {
      return;
    }
    const internalData = subjectListData[rowIndex]?.internalData;
    
    const editorColumnIndex = 7;
    if (columnIndex === editorColumnIndex) {
      const editorData = internalData?.editorData || [];
      if (editorData.length > 0) {
        setEditorDrawerData(editorData);
        setOpenEditorDrawer(true);
      } else {
        // notify.info("No Editor assigned");
      }
    }
  };
  const getRowIndex = (row) => {
    return subjectData?.rows?.indexOf(row) ?? -1;
  };

  // Filter editor list based on search
  const filteredEditorDrawerData = editorDrawerData.filter(editor =>
    (editor.name?.toLowerCase() || "").includes(editorSearch.toLowerCase()) ||
    (editor.role?.toLowerCase() || "").includes(editorSearch.toLowerCase())
  );

  return (
    <div className=" p-3 sm:p-4">
      {patientCycleConfirm ? (
        <ConfirmationModal
          open={patientCycleConfirm}
          setOpen={setPatientCycleConfirm}
          handleConfirmation={handlePatientCycleConfrim}
          errMessage={patientCycleErrMess}
          isLoading={patientCycleLoading}
        />
      ) : null}
      {openAddSubjectModal ? (
        <CustomModel
          rowId={rowId}
             modalInitialValues={

            rowId ? (isSwap ? initialValues : patientEdit) : AddNewSubjectPhase

          }
          initialValuesValidationSchema={
            rowId
              ? isSwap
                ? ReAssignValidationSchema
                : editSubjectPhaseValidationSchema(phaseTypeName === "trial")
              : addNewSubjectPhaseValidationSchema(phaseTypeName === "trial")
          }
          open={openAddSubjectModal}
          setOpen={setOpenAddSubjectModal}
          setModelData={setSubjectModelData}
          modelData={subjectModelData}
          handleModelValues={
            rowId
              ? isSwap
                ? handleOpenAssignPiAndEditorModal
                : handleEditSubjectSubmit
              : handleAddSubject
          }
          isLoadingBtn={rowId ? (isSwap ? assigningPiLoader : isEditFormLoading) : isAddSubjectLoading}
          onChange={(value, fieldName) => {
            if (fieldName === "investigator_id") {
 getEditorDropdown(value, !!rowId);
  if (!rowId) { // For add patient modal only
        setPatientEdit(prev => ({
          ...prev,
          editor_id: ""
        }));
      }       
     }
          }}
          key={rowId ? `reassign-${rowId}` : 'add-patient'} // Add key to force re-render

        />
      ) : (
        <>
          {initialPhaseModal ? (
            <CustomModel
              modalInitialValues={AddPhase}
              initialValuesValidationSchema={addPhaseValidationSchema}
              open={initialPhaseModal}
              setOpen={setInitialPhaseModal}
              setModelData={setModelData}
              modelData={modelData}
              handleModelValues={handleAddVisitNumber}
              isLoadingBtn={isAddPrLoading}
              onChange={handleTemplateList}
            />
          ) : null}
          <CustomPhaseModel
            open={openAddPhaseModal}
            setOpen={setOpenAddPhaseModal}
            setModelData={setVisitFrequencyModelData}
            modelData={visitFrequencyModelData}
            handleModelValues={templateList}
            setModelValues={setTemplateList}
            onChange={handleTemplateList}
            handleVisitFrequency={handleVisitFrequency}
            setSecondPhaseModal={setInitialPhaseModal}
            setTemplateTypeIds={setTemplateTypeIds}
            getTemplateId={getTemplateTypeIds}
            setSelectFormType={setSelectFormType}
            selectFormType={selectFormType}
            page={page}
            setPage={setPage}
            maxPages={maxPages}
            loadMoreData={loadMoreData}
            setIsAddPhaseLoading={setIsAddPhaseLoading}
            setIsTrialInfoLoading={setIsTrialInfoLoading}
            setCount={setCount}
            count={count}
          />

          <CustomModel
            modalInitialValues={visitNumberIntialValue}
            initialValuesValidationSchema={() =>
              addVisitTypeNumValidationSchema(visitNumberModelData)
            }
            open={openVisitNumberModel}
            setOpen={setOpenVisitNumberModel}
            setModelData={setVisitNumberModelData}
            modelData={visitNumberModelData}
            handleModelValues={handleAddVisitNumber}
            isLoadingBtn={isAddPrLoading}
            onChange={handleTemplateList}
          />
        </>
      )}

      {openExportModal ? (
        <CustomModel
          rowId={rowId}
          modalInitialValues={exportFormCsv}
          initialValuesValidationSchema={addFormExportSchema}
          open={openExportModal}
          setOpen={setOpenExportModal}
          setModelData={() => { }}
          modelData={exportModelData}
          handleModelValues={
            exportType === "csv" 
              ? handleExportModel 
              : handleExcelExportModel
          }
          isLoadingBtn={exportLoading}
          onChange={handleExportSelect}
          loader={exportLoading}
          handleExportButton={handleExportButton}
          showExcelExportButton={role_id === 1 || role_id === 4}
          handleExcelExportButton={handleExcelExportButton}
        />
      ) : null}

      {openEditSubjectIdModal ? (
        <CustomModel
          rowId={rowId}
          modalInitialValues={patientEditId}
          initialValuesValidationSchema={validateEditSubjectId}
          open={openEditSubjectIdModal}
          setOpen={setOpenEditSubjectIdModal}
          setModelData={() => { }}
          modelData={defaultEditSubjectId}
          handleModelValues={handleSavePatientId}
          isLoadingBtn={editIdLoading}
          loader={editIdLoading}
        />
      ) : null}

      <div className="mb-0 md:mb-4">
        <BreadCrumb
          BreadCrumbsListing={[
            { name: "Products", path: "products" },
            {
              name: `${productDetails?.name || ""} Details`,
              path: location.pathname,
            },
          ]}
        />
      </div>
      <div className="mt-3 md:mt-5">
        <TaskManagementHeader
          SearchbarPlaceholder="Search by Name"
          width={"100%"}
          ButtonText="Add Phase"
          ButtonAuth={{ module: "trials", auth: 10 }}
          handleButtonClick={handleAddPhaseModal}
          handleSearch={handlePhaseSearch}
          showExportButton={role_id === 1 || role_id === 4}
          showExcelExportButton={role_id === 1 || role_id === 4}
          handleExcelExportButton={handleExcelExportButton}
        />
      </div>

      {loading.page ? (
        <div className="pt-3">
          <SkeletonLoader variant="rectangular" height={400} sx={{ borderRadius: 2 }} />
        </div>
      ) : !phaseListData || phaseListData?.length === 0 ? (
        <div className="col-start-4 col-end-13">
          <NoDataCard  heading="Phase does not exist" />
        </div>
      ) : (
        <div className="pt-3">
          <CustomTabs
            phases={phaseListData}
            activePhaseId={activeTab}
            onPhaseChange={handlePhaseTabChange}
            onAddPatient={handleOpenAddSubjectModal}
            onEditPhase={handleEdit}
            onDeletePhase={handleDelete}
            onExportData={handleExportButton}
            disableAddButton={disableButton}
            loading={loading.phaseList}
            phaseDetails={phaseListDetails}
          />
        
          {loading.phaseDetail || loading.phaseList ? (
  <div className="col-start-4 col-end-13 min-h-[25rem] bg-white rounded-xl p-6">
    {/* Top section */}
    <div className="mb-8">
      <Skeleton variant="text" width="70%" height={32} sx={{ mb: 2 }} />
      <Skeleton variant="text" width="50%" height={20} sx={{ mb: 1 }} />
      <Skeleton variant="text" width="40%" height={20} />
    </div>

    {/* Middle sections */}
    <div className="space-y-6">
      {[1, 2, 3, 4].map((section) => (
        <div key={section}>
          <Skeleton variant="text" width={160} height={24} sx={{ mb: 3 }} />
          <div className="flex gap-4">
            <Skeleton variant="rectangular" width={120} height={48} sx={{ borderRadius: '6px' }} />
            <Skeleton variant="rectangular" width={120} height={48} sx={{ borderRadius: '6px' }} />
          </div>
        </div>
      ))}
    </div>

    {/* Bottom table area */}
    <div className="mt-8 pt-6 border-t border-gray-100">
      <Skeleton variant="text" width={200} height={28} sx={{ mb: 4 }} />
      <div className="space-y-3">
        {[1, 2, 3, 4, 5].map((row) => (
          <Skeleton key={row} variant="rectangular" width="100%" height={40} sx={{ borderRadius: '4px' }} />
        ))}
      </div>
    </div>
  </div>
) : isPhaseExist ? (
            <div className="col-start-4 col-end-13">
              <NoDataCard heading="Phase does not exist" />
            </div>
          )
            :
            <div className="col-start-4 col-end-13 min-h-[25rem] bg-[#FFFFFF] ">
              {loading.phaseDetail ? (
                <SkeltonLoaderHeader
                  rowCount={2}
                  isTable={false}
                  width={200}
                  height={30}
                />
              ) : (
                <CustomWrapperCard
                  editDeleteBtn={true}
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                  data={phaseListDetails || {}}
                  loading={isAddPhaseLoading}
                  handleAddButtonCard={handleOpenAddSubjectModal}
                  disableAddButton={disableButton}
                  onExportButton={handleExportButton}
                  />
              )}

              <div >
                <TrialInfoComponent
                  HeaderTitle={"Description"}
                  ShowHeaderButton={false}
                  loading={isTrialInfoLoading}
                >
                  {loading.phaseDetail ? (
                    <SkeletonLoader
                      rowCount={1}
                      isTable={false}
                      width={500}
                      height={20}
                    />
                  ) : (
                    <Typography variant="p" className="break-words">
                      {phaseListDetails?.description?.[0]?.toUpperCase() +
                        phaseListDetails?.description?.slice(1) ||
                        "No Description Added"}
                    </Typography>
                  )}
                </TrialInfoComponent>
              </div>

              <CustomAccordion
                accordionClassName={"w-100"}
                rootDivClass={"pb-3"}
                expanded={phaseListDetails?.form_details?.length!==0 &&expand === "assignedForms"}
                handleExpansion={() => {
                  if(phaseListDetails?.form_details?.length!==0){handleExpand("assignedForms")}}}
                noBorderDetail={true}
                title={phaseListDetails?.form_details?.length===0?"Assigned Forms(No Assigned Forms Found)":"Assigned Forms"}
                disabled={phaseListDetails?.form_details?.length===0}
              >
                <TrialInfoComponent
                  ShowHeaderButton={false}
                  loading={isTrialInfoLoading}
                >
                  <div className="flex gap-2 justify-start flex-wrap">
                    {loading.phaseDetail ? (
                      <SkeletonLoader
                        rowCount={2}
                        isTable={false}
                        width={200}
                        height={30}
                      />
                    ) : (
                      <>
                        {phaseListDetails?.form_details?.length > 0
                          ? phaseListDetails?.form_details?.map((item) => (
                            <CustomDetailComponent
                              key={item?.id || ""}
                              BgColor="#2831720D"
                              FirstHeading={item.title || ""}
                              Icon={<DocumentIcon LightBlue={true} />}
                              ShowDeleteIcon={false}
                            />
                          ))
                          : "No Assigned Form Found."}
                      </>
                    )}
                  </div>
                </TrialInfoComponent>
              </CustomAccordion>

               <CustomAccordion
                accordionClassName={"w-100"}
                rootDivClass={"pb-3"}
               expanded={phaseListDetails?.investigator_details?.principal_investigator?.length!==0 && expand === "principalInvestigator"}
                handleExpansion={() => {
                   if (phaseListDetails?.investigator_details?.principal_investigator?.length!==0) {
                  handleExpand("principalInvestigator")}
                   }}
                // title={phaseListDetails?.investigator_details?.principal_investigator?.length===0 ? "Principal Investigator(No Principal Investigator Found)":`Principal Investigator`}
                      title={
                        (() => {
                          const isCommercial = phaseListDetails?.phase_type_details?.name?.toLowerCase() === "commercial";
                          const label = isCommercial ? "HCP" : "Principal Investigator";
                          const isEmpty = phaseListDetails?.investigator_details?.principal_investigator?.length === 0;
                          return isEmpty
                            ? `${label} (No ${label} Found)`
                            : label;
                        })()
                      }
                noBorderDetail={true}
                 disabled={phaseListDetails?.investigator_details?.principal_investigator?.length===0 }
              >
                <TrialInfoComponent
                  ShowHeaderButton={false}
                  loading={isTrialInfoLoading}
                >
                  <div className="flex gap-2 justify-start flex-wrap">
                    {loading.phaseDetail ? (
                      <SkeletonLoader
                        rowCount={3}
                        isTable={false}
                        width={200}
                        height={30}
                      />
                    ) : (
                      <>
                        {phaseListDetails?.investigator_details
                          ?.principal_investigator?.length > 0
                          ? phaseListDetails?.investigator_details?.principal_investigator?.map(
                            (item) => (
                              <div key={item?.id} className="w-full sm:w-max">
                                <CustomDetailComponent
                                  BgColor="#2831720D"
                                  FirstHeading={item?.name || ""}
                                  SecondHeading={
                                    item?.hospital_details?.name || ""
                                  }
                                  Icon={<InvestigatorIcon />}
                                  ShowDeleteIcon={false}
                                />
                              </div>
                            )
                          )
                          : "No Principal Investigator Found."}
                      </>
                    )}
                  </div>
                </TrialInfoComponent>
              </CustomAccordion>

                 <CustomAccordion
                accordionClassName={"w-100"}
                rootDivClass={"pb-3"}
                expanded={phaseListDetails?.immunoactQA_details?.length!==0 && expand === "QualityAssociate"}
                handleExpansion={() => {
                  if (phaseListDetails?.immunoactQA_details?.length!==0) {
                    handleExpand("QualityAssociate")
                  }}}
                title={phaseListDetails?.immunoactQA_details?.length===0? "Quality Associate (No Quality Associate Found)" : "Quality Associate"}
                noBorderDetail={true}
                  disabled={phaseListDetails?.immunoactQA_details?.length===0}
              >
               <TrialInfoComponent
                ShowHeaderButton={false}
                loading={isTrialInfoLoading}
              >
                <div className="flex gap-2 justify-start flex-wrap">
                  {loading.phaseDetail ? (
                    <SkeletonLoader
                      rowCount={3}
                      isTable={false}
                      width={200}
                      height={30}
                    />
                  ) : (
                    <>
                      {phaseListDetails?.immunoactQA_details?.length > 0
                        ? phaseListDetails?.immunoactQA_details?.map((item) => (
                          <div key={item?.id} className="w-full sm:w-auto">
                            <CustomDetailComponent
                              BgColor="#2831720D"
                              FirstHeading={item?.name || ""}
                              Icon={<PersonSvg />}
                              ShowDeleteIcon={false}
                            />
                          </div>
                        ))
                        : "No Quality Associate Found."}
                    </>
                  )}
                </div>
              </TrialInfoComponent>
              </CustomAccordion>
              <CustomAccordion
                accordionClassName={"w-100"}
                rootDivClass={"pb-3"}
                expanded={phaseListDetails?.trial_manager_details?.length!==0 && expand === "clinicalPhaseManager"}
                handleExpansion={() => {
                  if(phaseListDetails?.trial_manager_details?.length!==0){
   handleExpand("clinicalPhaseManager")
                  }
                }}
                title={phaseListDetails?.trial_manager_details?.length===0 ? "Clinical Phase Manager (No Clinical Phase Manager Found)" : "Clinical Phase Manager"}
                noBorderDetail={true}
                  disabled={phaseListDetails?.trial_manager_details?.length===0 }
              >
              <TrialInfoComponent
                ShowHeaderButton={false}
                loading={isTrialInfoLoading}
              >
                <div className="flex gap-2 justify-start flex-wrap">
                  {loading.phaseDetail || loading.phaseList ? (
                    <SkeletonLoader
                      rowCount={3}
                      isTable={false}
                      width={200}
                      height={30}
                    />
                  ) : (
                    <>
                      {phaseListDetails?.trial_manager_details?.length > 0
                        ? phaseListDetails?.trial_manager_details?.map((item) => (
                          <div key={item?.id} className="w-full sm:w-auto">
                            <CustomDetailComponent
                              BgColor="#2831720D"
                              FirstHeading={item.name}
                              Icon={<PersonSvg />}
                              ShowDeleteIcon={false}
                            />
                          </div>
                        ))
                        : "No Clinical Phase Manager Found."}
                    </>
                  )}
                </div>
              </TrialInfoComponent>
              </CustomAccordion>

                    <CustomAccordion
                      accordionClassName={"w-100"}
                      rootDivClass={"pb-3"}
                      expanded={phaseListDetails?.phase_project_managers?.length !== 0 && expand === "projectManager"}
                      handleExpansion={() => {
                        if (phaseListDetails?.phase_project_managers?.length !== 0) {
                          handleExpand("projectManager")
                        }
                      }}
                      title={phaseListDetails?.phase_project_managers?.length === 0 ? "Patient Navigators (No Patient Navigators Found)" : "Patient Navigators"}
                      noBorderDetail={true}
                      disabled={phaseListDetails?.phase_project_managers?.length === 0}
                    >
              <TrialInfoComponent
                ShowHeaderButton={false}
                loading={isTrialInfoLoading}
              >
                <div className="flex gap-2 justify-start flex-wrap">
                  {loading.phaseDetail || loading.phaseList ? (
                    <SkeletonLoader
                      rowCount={3}
                      isTable={false}
                      width={200}
                      height={30}
                    />
                  ) : (
                    <>
                      {phaseListDetails?.phase_project_managers?.length > 0
                        ? phaseListDetails?.phase_project_managers?.map((item) => (
                          <div key={item?.id} className="w-full sm:w-auto">
                            <CustomDetailComponent
                              BgColor="#2831720D"
                              FirstHeading={item.name}
                              Icon={<PersonSvg />}
                              ShowDeleteIcon={false}
                            />
                          </div>
                        ))
                        : "No Patient Navigators Found."}
                    </>
                  )}
                </div>
              </TrialInfoComponent>
        </CustomAccordion>

              <div className="p-3">
                <CustomTable
                  SearchbarBgColor="secondary"
                  rows={subjectData?.rows}
                  columnAlign={subjectData?.columnAlign}
                  columns={subjectData?.columns}
                  handleTableFilters={handleTableFilters}
                  tableFilters={tableFilters}
                  handleChangePage={handlePagination}
                  handleSwapButton={handleSwapButton}
                  handleEditButton={handleEditSubject}
                  handleEditSubjectId={handleEditSubjectid}
                  loading={loading.table}
                  currentPage={currentPage}
                  totalpage={totalPage}
                  TableData={{
                    ...subjectData?.TableSearchActions,
                    filters: subjectData?.TableSearchActions?.filters?.map(
                      (item) => {
                        if (item?.id === "editorList") {
                          return {
                            ...item,
                            MenuList: editorList,
                            dropDownValue: editorId,
                          };
                        } else if (item?.id === "selectPI") {
                          return {
                            ...item,
                            MenuList: pIList,
                            dropDownValue: piId,
                          };
                        }
                        return item;
                      }
                    ),
                  }}
                  order={order}
                  orderBy={orderBy}
                  EnableSorting={true}
                  handleSort={handleSort}
                  handleChangeDropDown={handleDropDownChange}
                  handleNavigate={handleNavigateToDetails}
                  handleTableDataButton={handleOpenAddSubjectModal}
                  DropdownBgColor={theme?.palette?.grey[200]}
                  disableButton={disableButton}
                  handleCellClick={(row, columnIndex) => {
                    handleCellClick(row, columnIndex);
                  }}
                />
              </div>
            </div>
}
</div>
      )}

      <DeleteConfirmContent
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        handleDelete={handleDeletePhase}
        isLoading={isDeleteLoading}
      />
       {/* <CustomSnackbar
        open={snackbar?.value}
        setOpen={setSnackbar}
        color={snackbar?.color}
        message={snackbar?.message}
      /> */}

      <AddPiAndEditorForAllModalContent
        open={openAssignForAllModal}
        setOpen={setOpenAssignForAllModal}
        handleClick={SumbitAssignAllPiAndEditor}
        isLoading={assigningPiLoader}
      />
      {openEditorDrawer && (
        <CustomDrawer open={openEditorDrawer} toggleDrawer={() => setOpenEditorDrawer(!openEditorDrawer)}>
          <div className="w-[25rem]">
            <div className="pl-4 pt-4 pr-4">
              <HeaderBackNav
                handleBackNav={() => setOpenEditorDrawer(false)}
                TitleFontSize={"18px"}
                TitleFontWeight={700}
                Title="Editor/Patient Navigators Details"
              />
            </div>
            <hr />
            <div className="pl-3 pt-3 pr-3">
              <CustomSearchbar
                Placeholder="Search by Name or Role"
                BgColor="#dfe0eb"
                value={editorSearch}
                handleSearch={(value) => setEditorSearch(value)}
              />
              <ul className="p-2 cursor-pointer">
                {loading.table ? (
                  <SkeletonLoader rowCount={1} height={"35px"} />
                ) : filteredEditorDrawerData?.length === 0 ? (
                  <div className="mt-4">
                    <Typography variant="body1" className="text-center text-gray-500">
                      No details available
                    </Typography>
                  </div>
                ) : (
                  filteredEditorDrawerData?.map((editor, index) => (
                    <li
                      key={editor?.id || index}
                      className="flex gap-3 align-center pt-2 pb-2"
                      style={{ borderBottom: "2px solid #dfe0eb" }}
                    >
                      <div className="self-center">
                        <PersonSvg />
                      </div>
                      <div className="self-center">
                        <Typography variant="h6">
                          {editor?.name || "Name not available"}
                        </Typography>
                        {editor?.role && (
                          <Typography variant="body2" color="textSecondary">
                            Role: {editor.role}
                          </Typography>
                        )}
                      </div>
                    </li>
                  ))
                )}
              </ul>
            </div>
          </div>
        </CustomDrawer>
      )}
    </div>
  );
};